export default "__VITE_ASSET__B3LjGTXL__"